import React, {useEffect, useState} from 'react';
import {AvField, AvForm} from "availity-reactstrap-validation";
import {useParams} from "react-router-dom";
import axios from "axios";
import {API_PATH} from "../../../components/const";
import {toast} from "react-toastify";

const SystemInformation = () => {
    let params = useParams()
    const [data, setData] = useState([])
    const prepareObject = (v) => {

    }
    const getData = () => {
        axios.get(API_PATH +"company/" + localStorage.getItem("id") + "/camera/smartcamera/detail/" + params?.id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    useEffect(() => {
        getData()
    }, []);
    return (
        <div className="system-information main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Settings</span>
            </div>

            <div className="camera-config-content">
                <div className="my-avform">
                    <AvForm onValidSubmit={(e, v) => prepareObject(v)}>
                       <div className="row">
                           <div className="col-md-6">
                               <AvField
                                   name="test1"
                                   label="IP Address"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test2"
                                   label="Web Port"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test3"
                                   label="MAC"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test4"
                                   label="Version"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test5"
                                   label="Platform Library Version"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test6"
                                   label="UI Library Version"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test7"
                                   label="AI Library Version"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test8"
                                   label="Web Version"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                           </div>
                           <div className="col-md-6">
                               <AvField
                                   name="test11"
                                   label="Device ID"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test12"
                                   label="Device Name"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                               <AvField
                                   name="test13"
                                   label="Device Language"
                                   // value={item.value ? item.value : ""}
                                   placeholder="text"
                               />
                           </div>
                       </div>
                    </AvForm>
                    <div className="d-flex justify-content-end">
                        <button className="add-btn">Change password</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SystemInformation;